// src/pages/LandingPage.js
import React, { useContext, useLayoutEffect, useRef, useState } from "react";
import { AuthContext } from "../auth/AuthProvider";
import "./LandingPage.css";

import CBRNButtons from "../components/CBRNButtons";
import TimezoneClock from "../components/TimezoneClock/TimezoneClock";
import WeatherWidget from "../components/WeatherWidget/WeatherWidget";
import CalendarWidget from "../components/CalendarWidget/CalendarWidget";
import TrendingNowWidget from "../components/TrendingNowWidget/TrendingNowWidget";
import TBOutbreakAlert from "../components/tbOutbreak/TBOutbreakAlert";

export default function LandingPage() {
  const { profile, logout } = useContext(AuthContext);
  const username = profile?.preferred_username || profile?.email || "user";

  const rightRef = useRef(null);
  const [rightH, setRightH] = useState(0);

  useLayoutEffect(() => {
    const el = rightRef.current;
    if (!el) return;

    let raf1 = 0;
    let raf2 = 0;
    let ro = null;

    const measure = () => {
      const h = Math.round(el.getBoundingClientRect().height || 0);
      if (h > 0) setRightH((prev) => (prev === h ? prev : h));
    };

    measure();

    raf1 = requestAnimationFrame(() => {
      measure();
      raf2 = requestAnimationFrame(measure);
    });

    ro = new ResizeObserver(measure);
    ro.observe(el);

    const onVis = () => {
      if (!document.hidden) {
        requestAnimationFrame(measure);
      }
    };
    document.addEventListener("visibilitychange", onVis);

    window.addEventListener("resize", measure);

    return () => {
      if (ro) ro.disconnect();
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2);
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("resize", measure);
    };
  }, []);

  return (
    <div className="pageContainer">
      <TBOutbreakAlert />

      {/* ===== HEADER LINE ===== */}
      <div className="ds-header lp-header-top">
        <h1 className="ds-title">Dashboard Homepage</h1>

        <div className="lp-userchip">
          <span className="lp-welcome">
            Welcome, <b>{username}</b>
          </span>
          <button type="button" className="lp-logout" onClick={logout}>
            Logout
          </button>
        </div>
      </div>

      {/* ===== WIDGETS ROW ===== */}
      <div
        className="lp-header-widgets"
        style={rightH > 0 ? { ["--rightH"]: `${rightH}px` } : undefined}
      >
        <div className="lp-trends-wrap">
          <TrendingNowWidget />
        </div>

        <div className="lp-weather-wrap">
          <WeatherWidget />
        </div>

        <div className="lp-right-stack" ref={rightRef}>
          <TimezoneClock />
          <CalendarWidget />
        </div>
      </div>

      {/* ===== MAIN ===== */}
      <div className="ds-grid lp-main">
        <div className="ds-col-12 ds-card lp-cbrn-card">
          <CBRNButtons />
        </div>
      </div>
    </div>
  );
}
